import { useState } from 'react';

interface ShareModalProps {
  open: boolean;
  shareUrl: string;
  title: string;
  onClose: () => void;
}

const channels = [
  { icon: 'ri-wechat-line', label: '微信' },
  { icon: 'ri-weibo-line', label: '微博' },
  { icon: 'ri-bilibili-line', label: '哔哩哔哩' },
  { icon: 'ri-link', label: '复制链接' },
];

export default function ShareModal({ open, shareUrl, title, onClose }: ShareModalProps) {
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch {
      // clipboard unavailable
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-primary-950/70" onClick={onClose} aria-hidden="true" />
      <div className="relative w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-6">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">分享作品</h3>
            <p className="mt-1 text-xs text-secondary-500">把《{title}》推荐给朋友</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-600 transition-colors hover:bg-background-100"
            aria-label="关闭"
          >
            <i className="ri-close-line text-xl" aria-hidden="true" />
          </button>
        </div>

        <div className="mt-5 grid grid-cols-4 gap-3">
          {channels.map((item) => (
            <button
              key={item.label}
              type="button"
              onClick={item.label === '复制链接' ? handleCopy : undefined}
              className="flex flex-col items-center gap-2 rounded-md border border-background-200 py-3 transition-colors hover:border-accent-400"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-primary-600">
                <i className={`${item.icon} text-lg`} aria-hidden="true" />
              </span>
              <span className="text-[11px] text-foreground-700">{item.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-5">
          <label htmlFor="share-url" className="text-xs font-medium text-secondary-500">
            分享链接
          </label>
          <div className="mt-1.5 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2">
            <input
              id="share-url"
              readOnly
              value={shareUrl}
              className="w-full min-w-0 bg-transparent text-xs text-foreground-700 outline-none"
            />
            <button
              type="button"
              onClick={handleCopy}
              className="shrink-0 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              {copied ? '已复制' : '复制'}
            </button>
          </div>
        </div>

        <p className="mt-4 text-[11px] text-secondary-500">提示：社交分享渠道为演示效果，链接可复制分享。</p>
      </div>
    </div>
  );
}